export const infoFooter = [
  {
    className: 'pull-left out-margin',
    name: 'politicas-privacidade',
    href: 'https://www.portoseguro.com.br/privacidade',
    target: '_blank',
    info: 'Privacidade'
  },
  {
    className: 'pull-left out-margin',
    name: 'suporte',
    href: '/#/suport',
    target: '_blank',
    info: 'Suporte',
  },
  {
    className: 'pull-left out-margin',
    name: 'cookie-config',
    style: {cursor: "pointer"},
    innerClassName: 'ot-sdk-show-settings',
    info: 'Configurações dos cookies',
  },
  {
    className: 'pull-left out-margin',
    name: 'porto seguro',
    href: '#',
    info: `© ${new Date().getFullYear()} Porto`
  },
];



// WEBPACK FOOTER //
// ./src/components/Footer/FooterData.js